const xhr = new XMLHttpRequest
const requestedUrl = 'https://cam.payou.fr/web/cgi-bin/hi3510/param.cgi?cmd=preset&-act=goto&-number='
const authorizationKey = 'dXNlcjpyb2JpbmRyNDAw'
const cameraPositionSelector = document.querySelector('#cameraPositionsSelector') as HTMLInputElement

cameraPositionSelector.addEventListener('change', function() {
    sendRequest(this.value)
})

function sendRequest(value: string) {
    xhr.open('GET', requestedUrl + value, false)
    xhr.setRequestHeader("Content-type",'application/json')
    xhr.setRequestHeader("Authorization",'Basic ' + authorizationKey)
    xhr.withCredentials = false
    try{
        xhr.send()
    }catch (e) {
        console.log(e)
    }
}